export default {"src":"/_next/static/media/minillus-testimony.31701f0a.svg","height":57,"width":56,"blurWidth":0,"blurHeight":0};